import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createtext">
                1.&nbsp;<span className="material-symbols-outlined">format_size</span>&nbsp;{translate('createtext')}
            </Typography>
            <p><strong>{translate('createtext')}</strong> テキストを作成するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストの値の保存先</td>
                                <td>$text_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>作りたいテキスト</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>The quick brown fox, jumps over the dog.</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>The quick brown fox, jumps over the dog.</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="splittext">
                2.&nbsp;<span className="material-symbols-outlined">cut</span>&nbsp;{translate('splittext')}
            </Typography>
            <p><strong>{translate('splittext')}</strong>区切り文字<strong>delimiter</strong>でテキストを複数の部分に分割アクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>分割後の値の保存先</td>
                                <td>$splitText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>分割したいテキスト</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('splitwith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>区切り文字</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>テキストをカンマ (,) で 1 つの配列に分割します。</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$splitText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>$text1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('splitwith')}</span>
                            <div>,</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "The quick brown fox"
                                            ," jumps over the dog."
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="replacetext">
                3.&nbsp;<span className="material-symbols-outlined">find_replace</span>&nbsp;{translate('replacetext')}
            </Typography>
            <p><strong>{translate('replacetext')}</strong> テキスト内の文字列を別の文字列に置き換えるアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>置換後の値の保存先</td>
                                <td>$replaceText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>置換したいテキスト</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('find')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>置換対象文字列</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('replacewith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>置換後文字列</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p> <strong>dog</strong>の文字を<strong>monkey</strong>に置換します</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$replaceText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>$text1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('find')}</span>
                            <div>dog</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('replacewith')}</span>
                            <div>monkey</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>The quick brown fox, jumps over the monkey.</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="matchtext">
                4.&nbsp;<span className="material-symbols-outlined">search</span>&nbsp;{translate('matchtext')}
            </Typography>
            <p><strong>{translate('matchtext')}</strong> 正規表現を使用してテキストを検索し、一致した文字列を配列として返すアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストのマッチング後の保存先</td>
                                <td>$splitText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>検索したいテキスト</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('regexp')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>正規表現</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p><strong>a</strong> ～ <strong>z</strong>, <strong>A</strong> ～ <strong>Z</strong>を含むすべての文字列を検索します。</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$splitText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>$text1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('find')}</span>
                            <div>([a-zA-Z])+</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "The",
                                            "quick",
                                            "brown",
                                            "fox",
                                            "jumps",
                                            "over",
                                            "the",
                                            "dog"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readtext">
                5.&nbsp;<span className="material-symbols-outlined">description</span>&nbsp;{translate('readtext')}
            </Typography>
            <p><strong>{translate('readtext')}</strong> ファイルからテキストを読み取るアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキスト読込後の保存先</td>
                                <td>$readText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>txt ファイルのパス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストファイルの文字コードを指定</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$readText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file.txt</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Hello world !!!</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertpdftotext">
                6.&nbsp;<span className="material-symbols-outlined">picture_as_pdf</span>&nbsp;{translate('convertpdftotext')}
            </Typography>
            <p><strong>{translate('convertpdftotext')}</strong> DFファイルからテキスト情報のみを抽出し、文字列として処理できるようにするアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>PDFをテキストに変換後の保存先</td>
                                <td>$pdfToText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>pdf ファイルのパス</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$pdfToText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Hello world !!!</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertpdftotext">
                7.&nbsp;<span className="material-symbols-outlined">edit_document</span>&nbsp;{translate('appendvaluetotextfile')}
            </Typography>
            <p><strong>{translate('appendvaluetotextfile')}</strong> テキストファイル内の特定の位置にテキストを追加するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストファイルに値を追加後の保存先</td>
                                <td>$textFile</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>txt ファイルのパス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>追加文字</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('position')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストを追加する位置です。ファイルの先頭に追加する場合は値<strong>0</strong>を指定し、<strong>end</strong>を指定すると、末尾に文字を追加されます。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストファイルの文字コードを指定</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$textFile</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file.txt</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>Wellcome to RPA CLOUD.</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('position')}</span>
                            <div>end</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Hello world !!!Wellcome to RPA CLOUD.</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);